import type {
  ObservabilitySource,
  ObservabilitySourceStatus,
} from '@/lib/api/observability';

const unavailableStatuses = new Set<ObservabilitySourceStatus>([
  'unavailable',
  'not_configured',
]);

const sourceStatusSeverity: Record<ObservabilitySourceStatus, number> = {
  ok: 0,
  partial: 1,
  stale: 1,
  error: 2,
  unavailable: 2,
  not_configured: 2,
  forbidden: 2,
};

export function mergeObservabilitySources(
  ...sourceGroups: ObservabilitySource[][]
) {
  const sources = new Map<ObservabilitySource['id'], ObservabilitySource>();

  for (const source of sourceGroups.flat()) {
    const current = sources.get(source.id);
    if (
      !current ||
      sourceStatusSeverity[source.status] > sourceStatusSeverity[current.status]
    ) {
      sources.set(source.id, source);
    }
  }

  return [...sources.values()];
}

export function observabilityDataUnavailable(sources: ObservabilitySource[]) {
  return (
    sources.length > 0 &&
    sources.every((source) => unavailableStatuses.has(source.status))
  );
}

export function observabilitySourceUnavailable(
  sources: ObservabilitySource[],
  sourceId: ObservabilitySource['id'],
) {
  const source = sources.find((candidate) => candidate.id === sourceId);
  return Boolean(source && unavailableStatuses.has(source.status));
}

export function observabilitySourceCurrent(
  sources: ObservabilitySource[],
  sourceId: ObservabilitySource['id'],
) {
  return sources.find((source) => source.id === sourceId)?.status === 'ok';
}
